import { render, staticRenderFns } from "./AddressVersions.vue?vue&type=template&id=34d6fa0e&scoped=true"
import script from "./AddressVersions.vue?vue&type=script&lang=js"
export * from "./AddressVersions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d6fa0e",
  null
  
)

export default component.exports